export default __webpack_public_path__ + "static/media/Chanderi-Museum.dae8930a.jpg";